module.exports = __webpack_public_path__ + "img/timesaas-intro-h5.232fc11b.png";